import { useTranslation } from 'libs/i18n'
import { HistoryTable } from 'shared/components'
import { Header } from 'shared/components'
import { useFetchCategoryHistory } from './queries/useFetchCategoryHistory'

const CategoryHistory = () => {
	const { t } = useTranslation()

	const { categoryHistory, isCategoryLoading } = useFetchCategoryHistory()

	return (
		<>
			<Header title={t('Category / History')} />
			<HistoryTable results={categoryHistory?.data} isLoading={isCategoryLoading} />
		</>
	)
}

export default CategoryHistory
